import { render, staticRenderFns } from "./change-language.vue?vue&type=template&id=7ad936c3"
import script from "./change-language.vue?vue&type=script&lang=js"
export * from "./change-language.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports